// src/main.jsx
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'
import App from './App'
import './index.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import useGlobale from './components/global'
import DashboardDemandeur from './pages/DashboarDemandeur'
import ProfilePage from './pages/ProfilePage'
import ExperiencePage from './pages/ExperiencePage'
import CompetencesPage from './pages/CompetencesPages'
import LanguePage from './pages/LanguePage'
import DocumentPage from './pages/DocumentPage'
import ParametrePage from './pages/ParametrePage'
import { DiplomePage } from './pages/diplome'
import FormationPage from './pages/FormationPage'
import ListeDemandeur from './pages/demandeur'
import DashboardAdmin from './pages/dashboard'
import CarteAnpePage from './pages/CarteAnpePage'
import UtilisateurPage from './pages/UtilsateurPage'
import NotFoundPage from './pages/NotFoundPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import VerifyOTPPage from './pages/VerifyOTPPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import CentreInteretPage from './pages/CentreInteretPage'


// Écran de chargement pendant la rehydration du store
const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-green-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
      <p className="text-gray-500 text-sm">Chargement...</p>
    </div>
  </div>
);

// Composant pour protéger les routes
const PrivateRoute = ({ element: Component }) => {
  const { authenticated_anpe, _hasHydrated } = useGlobale();
  const navigate = useNavigate();

  useEffect(() => {
    if (_hasHydrated && !authenticated_anpe) {
      navigate('/connexion', {
        replace: true,
        state: { from: window.location.pathname }
      });
    }
  }, [authenticated_anpe, _hasHydrated, navigate]);

  // Attendre que le store soit rehydraté depuis localStorage
  if (!_hasHydrated) return <LoadingScreen />;

  return authenticated_anpe ? Component : null;
};

// Composant principal qui wrappe l'application
const AppRouter = () => {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        {/* Routes publiques */}
        <Route path="/connexion" element={<LoginPage />} />
        <Route path="/inscription" element={<RegisterPage />} />
        <Route path="/" element={<PrivateRoute element={<App />} />} />
        <Route path="/dashboard_demandeur" element={<PrivateRoute element={<DashboardDemandeur />} />} />
        <Route path="/profile" element={<PrivateRoute element={<ProfilePage />} />} />
        <Route path="/experiences" element={<PrivateRoute element={<ExperiencePage />} />} />
        <Route path="/competences" element={<PrivateRoute element={<CompetencesPage />} />} />
        <Route path="/langues" element={<PrivateRoute element={<LanguePage />} />} />
        <Route path="/documents" element={<PrivateRoute element={<DocumentPage />} />} />
        <Route path="/parametres" element={<PrivateRoute element={<ParametrePage />} />} />
        <Route path="/diplomes" element={<PrivateRoute element={<DiplomePage />} />} />
        <Route path="/formations" element={<PrivateRoute element={<FormationPage />} />} />
        <Route path="/liste-demandeurs" element={<PrivateRoute element={<ListeDemandeur />} />} />
        <Route path="/dashboard_admin" element={<PrivateRoute element={<DashboardAdmin />} />} />
        <Route path="/carte-anpe" element={<PrivateRoute element={<CarteAnpePage />} />} />
        <Route path="/centres-interet" element={<PrivateRoute element={<CentreInteretPage />} />} />
        <Route path="/gestion-des-comptes" element={<PrivateRoute element={<UtilisateurPage />} />} />

        {/* Réinitialisation de mot de passe */}
        <Route path="/mot-de-passe-oublie" element={<ForgotPasswordPage />} />
        <Route path="/verification-otp" element={<VerifyOTPPage />} />
        <Route path="/reinitialiser-mot-de-passe" element={<ResetPasswordPage />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);